export default __webpack_public_path__ + "static/media/holiday-banner.b0117722.jpg";